/**
 * @file StructuredData.js
 * @description This component adds structured data (Schema.org) to the website.
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { brand } from '../../config/brand';

/**
 * @component
 * @description This component adds structured data (Schema.org) to the website using `react-helmet-async`.
 * This helps search engines understand website content better.
 * @returns {JSX.Element} The rendered component.
 */
const StructuredData = () => {
  const logoUrl = `${brand.siteUrl}${brand.seo.ogImage}`;
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": brand.name,
    "url": brand.siteUrl,
    "logo": logoUrl,
    "description": brand.seo.description,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "url": `${brand.siteUrl}${brand.bookDemoPath}`
    },
    "sameAs": brand.socialLinks
  };

  const webSiteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": brand.name,
    "url": brand.siteUrl,
    "publisher": {
      "@type": "Organization",
      "name": brand.name,
      "logo": {
        "@type": "ImageObject",
        "url": logoUrl
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webSiteLd)}
      </script>
    </Helmet>
  );
};

export default StructuredData; 